import AgencyMaterials from 'client/common/components/agency-materials';

import './index.css';

export default AgencyMaterials;
